msgid ""
msgstr ""
"POT-Creation-Date: 2025-06-01 16:28-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: content.size
#: projects/har/tabs/Body/Header.tsx:36
msgid "{0, plural, one {# byte} other {# bytes}}"
msgstr "{0, plural, one {# byte} other {# bytes}}"

#. placeholder {0}: excludeValue.size
#: projects/har/toolbar/HostTypeModal.tsx:107
msgid "{0, plural, one {# host excluded} other {# hosts excluded}}"
msgstr "{0, plural, one {# host excluded} other {# hosts excluded}}"

#. placeholder {0}: includeValue.size
#: projects/har/toolbar/HostTypeModal.tsx:96
msgid "{0, plural, one {# host included} other {# hosts included}}"
msgstr "{0, plural, one {# host included} other {# hosts included}}"

#. placeholder {0}: entries.length
#: projects/har/App.tsx:347
msgid "{0, plural, one {# request.} other {# requests.}}"
msgstr "{0, plural, one {# request.} other {# requests.}}"

#. placeholder {0}: includeValue.size
#. placeholder {0}: excludeValue.size
#: projects/har/toolbar/MimeTypeModal.tsx:157
#: projects/har/toolbar/MimeTypeModal.tsx:168
msgid "{0, plural, one {# type included} other {# types included}}"
msgstr "{0, plural, one {# type included} other {# types included}}"

#: projects/har/components/AboutModal.tsx:69
msgid "<0>{selected}</0> is offered under the following terms:"
msgstr "<0>{selected}</0> is offered under the following terms:"

#: projects/har/components/AboutModal.tsx:74
msgid "<0>{selected}</0> is used under the following license:"
msgstr "<0>{selected}</0> is used under the following license:"

#: projects/har/components/AboutModal.tsx:105
msgid "About"
msgstr "About"

#: projects/har/toolbar/StatusCodeFilter.tsx:45
msgid "All"
msgstr "All"

#: projects/har/components/AboutModal.tsx:34
msgid "All Rights Reserved."
msgstr "All Rights Reserved."

#: projects/har/tabs/QuickType/index.tsx:117
msgid "Alphabetize"
msgstr "Alphabetize"

#: projects/har/tabs/Timeline.tsx:30
msgid "Blocked"
msgstr "Blocked"

#: projects/har/components/FilterModal.tsx:150
msgid "Clear"
msgstr "Clear"

#: projects/har/tabs/Timeline.tsx:32
msgid "Connect"
msgstr "Connect"

#: projects/har/App.tsx:176
#: projects/har/tabs/Body/index.tsx:236
msgid "Content"
msgstr "Content"

#: projects/har/App.tsx:177
msgid "Cookies"
msgstr "Cookies"

#: projects/har/tabs/Request.tsx:88
#: projects/har/tabs/Request.tsx:102
msgid "Copied to clipboard"
msgstr "Copied to clipboard"

#: projects/har/tabs/Request.tsx:78
msgid "Copy"
msgstr "Copy"

#: projects/har/tabs/Request.tsx:108
msgid "Copy as axios"
msgstr "Copy as axios"

#: projects/har/tabs/Request.tsx:94
msgid "Copy as fetch"
msgstr "Copy as fetch"

#: src/toolbar/DarkMode.tsx:39
msgid "Dark"
msgstr "Dark"

#: projects/har/toolbar/MimeTypeModal.tsx:117
msgid "Data Only"
msgstr "Data Only"

#: projects/har/tabs/Timeline.tsx:31
msgid "DNS"
msgstr "DNS"

#: projects/har/components/FilterModal.tsx:153
msgid "Done"
msgstr "Done"

#: projects/har/tabs/Body/Header.tsx:60
msgid "Download"
msgstr "Download"

#: projects/har/App.tsx:321
msgid "Drag a HAR file here."
msgstr "Drag a HAR file here."

#: projects/har/components/DropHarTips.tsx:21
msgid "Drop your HAR file here…"
msgstr "Drop your HAR file here…"

#: projects/har/tabs/Body/index.tsx:177
msgid "Editor"
msgstr "Editor"

#: projects/har/tabs/Cookies.tsx:47
#: src/components/KVTable.tsx:43
msgid "Empty"
msgstr "Empty"

#: projects/har/tabs/Body/JSONView.tsx:61
msgid "Evaluate"
msgstr "Evaluate"

#: projects/har/toolbar/HostTypeModal.tsx:57
msgid "Exclude background and telemetry"
msgstr "Exclude background and telemetry"

#: projects/har/toolbar/HostTypeModal.tsx:45
msgid "Excluded hosts"
msgstr "Excluded hosts"

#: projects/har/toolbar/MimeTypeModal.tsx:105
msgid "Excluded mime types"
msgstr "Excluded mime types"

#: projects/har/components/ViewStateDropdown.tsx:133
msgid "Export to clipboard"
msgstr "Export to clipboard"

#: projects/har/components/ViewStateDropdown.tsx:111
msgid "Export to file"
msgstr "Export to file"

#: projects/har/toolbar/HostTypeModal.tsx:118
msgid "Filter by host…"
msgstr "Filter by host…"

#: projects/har/toolbar/MimeTypeModal.tsx:179
msgid "Filter by mime types…"
msgstr "Filter by mime types…"

#: projects/har/components/ViewStateDropdown.tsx:37
msgid "Filter settings"
msgstr "Filter settings"

#: projects/har/tabs/PostData.tsx:211
#: projects/har/tabs/PostData.tsx:250
msgid "Form data"
msgstr "Form data"

#: projects/har/App.tsx:221
msgid "HAR files"
msgstr "HAR files"

#: projects/har/tabs/Response.tsx:32
#: projects/har/tabs/Response.tsx:34
#: projects/har/tabs/Request.tsx:67
#: projects/har/tabs/Request.tsx:69
msgid "Headers"
msgstr "Headers"

#: projects/har/App.tsx:211
msgid "Hide sidebar"
msgstr "Hide sidebar"

#: projects/har/toolbar/HostTypeModal.tsx:63
msgid "Host"
msgstr "Host"

#: projects/har/components/ViewStateDropdown.tsx:86
msgid "Import from clipboard"
msgstr "Import from clipboard"

#: projects/har/components/ViewStateDropdown.tsx:61
msgid "Import from file"
msgstr "Import from file"

#: projects/har/toolbar/HostTypeModal.tsx:47
msgid "Included hosts"
msgstr "Included hosts"

#: projects/har/toolbar/MimeTypeModal.tsx:107
msgid "Included mime types"
msgstr "Included mime types"

#: projects/har/components/Initiator.tsx:84
#: projects/har/components/Initiator.tsx:91
msgid "Initiator"
msgstr "Initiator"

#: projects/har/tabs/Body/index.tsx:176
msgid "Inspect"
msgstr "Inspect"

#: projects/har/tabs/PostData.tsx:209
#: projects/har/tabs/PostData.tsx:252
msgid "JSON"
msgstr "JSON"

#: projects/har/tabs/QuickType/index.tsx:85
msgid "Language"
msgstr "Language"

#: src/toolbar/DarkMode.tsx:36
msgid "Light"
msgstr "Light"

#: projects/har/tabs/PostData.tsx:181
#: projects/har/components/Loading.tsx:7
msgid "Loading"
msgstr "Loading"

#: projects/har/toolbar/MethodFilter.tsx:33
#: projects/har/toolbar/MethodFilter.tsx:36
msgid "Method"
msgstr "Method"

#: projects/har/tabs/Body/Header.tsx:31
msgid "MIME"
msgstr "MIME"

#: projects/har/toolbar/MimeTypeModal.tsx:123
msgid "Mime Type"
msgstr "Mime Type"

#: projects/har/tabs/PostData.tsx:248
msgid "Multipart form data"
msgstr "Multipart form data"

#: projects/har/tabs/QuickType/index.tsx:105
msgid "Name"
msgstr "Name"

#: projects/har/tabs/Body/index.tsx:240
msgid "No content to display."
msgstr "No content to display."

#: projects/har/tabs/Cookies.tsx:40
msgid "No cookie to display."
msgstr "No cookie to display."

#: projects/har/App.tsx:308
msgid "No entries available."
msgstr "No entries available."

#: projects/har/tabs/Response.tsx:33
#: projects/har/tabs/Request.tsx:68
msgid "No headers"
msgstr "No headers"

#: projects/har/tabs/Response.tsx:26
msgid "No status text"
msgstr "No status text"

#: projects/har/tabs/Body/index.tsx:96
msgid "Not applicable."
msgstr "Not applicable."

#: projects/har/App.tsx:228
msgid "Open file"
msgstr "Open file"

#: projects/har/tabs/PostData.tsx:216
#: projects/har/tabs/PostData.tsx:218
#~ msgid "Post data"
#~ msgstr "Post data"

#: projects/har/tabs/PostData.tsx:217
#: projects/har/tabs/PostData.tsx:233
#: projects/har/tabs/PostData.tsx:235
msgid "POST data"
msgstr "POST data"

#: projects/har/tabs/Body/index.tsx:181
msgid "Preview"
msgstr "Preview"

#: projects/har/tabs/Request.tsx:55
#: projects/har/tabs/Request.tsx:57
msgid "Query string"
msgstr "Query string"

#: projects/har/tabs/Timeline.tsx:35
msgid "Receive"
msgstr "Receive"

#: projects/har/App.tsx:174
msgid "Request"
msgstr "Request"

#: projects/har/components/EntryList.tsx:80
msgid "Request list"
msgstr "Request list"

#: projects/har/App.tsx:175
#: projects/har/tabs/Body/index.tsx:102
msgid "Response"
msgstr "Response"

#: projects/har/components/EntryList.tsx:66
msgid "Search"
msgstr "Search"

#: projects/har/components/FilterModal.tsx:118
msgid "Search…"
msgstr "Search…"

#: projects/har/components/AboutModal.tsx:86
msgid "Select a license to view its license."
msgstr "Select a license to view its license."

#: projects/har/tabs/Timeline.tsx:33
msgid "Send"
msgstr "Send"

#: projects/har/tabs/QuickType/index.tsx:81
msgid "Settings"
msgstr "Settings"

#: projects/har/App.tsx:211
msgid "Show sidebar"
msgstr "Show sidebar"

#: projects/har/tabs/Body/Header.tsx:35
msgid "Size"
msgstr "Size"

#: projects/har/components/ErrorMessage.tsx:6
msgid "Something went wrong: "
msgstr "Something went wrong: "

#: projects/har/tabs/Timeline.tsx:36
msgid "SSL"
msgstr "SSL"

#: projects/har/tabs/Timeline.tsx:27
msgid "Start"
msgstr "Start"

#: projects/har/toolbar/StatusCodeFilter.tsx:36
#: projects/har/toolbar/StatusCodeFilter.tsx:37
msgid "Status code"
msgstr "Status code"

#: projects/har/tabs/Request.tsx:89
#: projects/har/tabs/Request.tsx:103
msgid "Successfully copied to clipboard"
msgstr "Successfully copied to clipboard"

#: src/toolbar/DarkMode.tsx:42
msgid "System"
msgstr "System"

#: projects/har/tabs/PostData.tsx:236
msgid "Text"
msgstr "Text"

#: projects/har/tabs/Body/FontView.tsx:21
msgid "The quick brown fox jumps over the lazy dog."
msgstr "The quick brown fox jumps over the lazy dog."

#: src/toolbar/DarkMode.tsx:30
msgid "Theme switch"
msgstr "Theme switch"

#: projects/har/App.tsx:143
msgid "This file is not a valid HAR file."
msgstr "This file is not a valid HAR file."

#: projects/har/App.tsx:178
msgid "Timeline"
msgstr "Timeline"

#: projects/har/tabs/Timeline.tsx:23
#: projects/har/tabs/Timeline.tsx:24
msgid "Timings"
msgstr "Timings"

#: projects/har/tabs/Cookies.tsx:34
msgid "Title"
msgstr "Title"

#: projects/har/tabs/Timeline.tsx:37
msgid "Total"
msgstr "Total"

#: projects/har/tabs/Body/index.tsx:181
msgid "Type"
msgstr "Type"

#: projects/har/tabs/Cookies.tsx:37
msgid "Value"
msgstr "Value"

#: projects/har/tabs/Timeline.tsx:34
msgid "Wait"
msgstr "Wait"
